var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconJavscript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 64V0H64V64H0Z",
    fill: "#FFD600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8454 47.9058C43.0756 49.904 44.4125 51.8187 47.2445 51.8187C49.6231 51.8187 50.8712 50.6365 50.8712 49.0009C50.8712 47.0436 49.5805 46.3485 46.9636 45.2089L45.5289 44.5973C41.3885 42.8409 38.6347 40.64 38.6347 35.9911C38.6347 31.7067 41.9147 28.4462 47.04 28.4462C50.6898 28.4462 53.312 29.7102 55.2036 33.0205L50.7343 35.8773C49.7511 34.1209 48.688 33.4293 47.04 33.4293C45.3583 33.4293 44.2934 34.4907 44.2934 35.8773C44.2934 37.5911 45.36 38.2845 47.8223 39.3458L49.2569 39.9573C54.1369 42.0356 56.8889 44.1582 56.8889 48.9298C56.8889 54.0711 52.8285 56.8889 47.3778 56.8889C42.0463 56.8889 39.0187 54.2133 37.3334 50.9013L41.8454 47.9058ZM21.248 48.0516C22.1476 49.6622 23.5147 50.9013 25.4809 50.9013C27.3618 50.9013 28.4445 50.1582 28.4445 47.2693V28.4445H34.3698V48.1796C34.3698 54.1653 30.8978 56.8889 25.8276 56.8889C21.2463 56.8889 17.9396 53.7849 16.592 50.9013L21.248 48.0516Z",
    fill: "#000001"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJavscript);
export default __webpack_public_path__ + "static/media/icon-javscript.b71318431091a4f0b2c122b5aff75a09.svg";
export { ForwardRef as ReactComponent };